export async function parseAllKeys(
  obj: Record<string, unknown> | string,
  fct: (value: string, key?: string) => Promise<string> | string,
  parentKey: string = '',
): Promise<Record<string, unknown> | string> {
  if (typeof obj === 'string') {
    return fct(obj);
  } else {
    const result = obj as Record<string, unknown>;
    for (const key in result) {
      const fullKey = `${parentKey ? `${parentKey}.` : ''}${key}`;

      if (typeof result[key] === 'object' && result[key] !== null) {
        result[key] = await parseAllKeys(result[key] as Record<string, unknown>, fct, fullKey);
      } else {
        result[key] = await fct(result[key] as string, fullKey);
      }
    }
    return result;
  }
}
